import { Box } from "@mui/material";
import { APP_COLORS } from "../../enums";

interface SegmentedProgressBarProps {
  value: number;
  filledColor?: string;
  emptyColor?: string;
}

function SegmentedProgressBar({
  value,
  filledColor,
  emptyColor = "#E5DDF7",
}: SegmentedProgressBarProps) {
  const filledColorValue = filledColor || APP_COLORS.primaryLight3;

  return (
    <Box
      width="100%"
      height={8}
      sx={{
        position: "relative",
        backgroundColor: emptyColor,
        borderRadius: 0.5,
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: `${value}%`,
          height: "100%",
          backgroundColor: filledColorValue,
          borderRadius: 0.5,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `repeating-linear-gradient(
            to right,
            transparent 0,
            transparent 2.5px,
            ${emptyColor} 2.5px,
            ${emptyColor} 3.5px
          )`,
          backgroundSize: "4px 100%",
        },
      }}
    />
  );
}

export default SegmentedProgressBar;
